import { BaseModal } from "@/components/general/base-modal/BaseModal";

import { IFRAME_MODAL_MAX_WIDTH } from "../constants";
import { useIframeModal } from "../hooks/useIframeModal";
import style from "./IframeModal.module.css";

type IframeModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  iframeUrl: string;
};

export const IframeModal = ({
  isOpen,
  onClose,
  onSuccess,
  iframeUrl,
}: IframeModalProps) => {
  useIframeModal(onClose, onSuccess);

  return (
    <BaseModal
      isOpen={isOpen}
      maxWidth={IFRAME_MODAL_MAX_WIDTH}
      onClose={onClose}
      testId="iframe-modal"
      headerClassName={style.header}
      dialogClassName={style.dialog}
    >
      <iframe
        src={iframeUrl}
        title="payment-iframe"
        className={style.iframe}
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation"
      />
    </BaseModal>
  );
};
